module.exports = __webpack_public_path__ + "static/30bec9cd.brazilBg.png";